import React, {createRef} from 'react'
import { Translation } from 'react-i18next';
import { withTranslation } from 'react-i18next';
import Parent from '../../../common/parent';
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import { constants } from "../../../common/constants/constants";
import MonthlyReportsTable from '../monthly_reports_table/MonthlyReportsTable';
import BllinkUtils from '../../../common/utils/utils';
import {Currency} from "../../../common/currency";

const StringUtils = BllinkUtils.Strings;
class MonthlyCashFlowTable extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.monthly_report');
        this.printSectionRef = createRef();

        let monthsTexts = this.getSelectMonthForDropdown(props);

        BllinkLogger.info(`this.props.match.params for MonthlyCashFlowTable`, this.props.match.params)
        this.state = {
            monthInt: parseInt(props.match.params.month),
            monthsTexts: monthsTexts,
            rowLevelConditions: [
                {functionName: 'colorRowInRed', fieldName:'PaymentState', classes: 'red-row'},
            ],
            title: ''
        }

        this.onMonthChangedFunc = this.onMonthChanged.bind(this);
        this.tableTitle.bind(this);
        this.tableSubTitle.bind(this);
        this.onChequeDepositClickFunc = this.onChequeDepositClick.bind(this);
    }


    async componentDidMount(){
        BllinkLogger.info(`componentDidMount monthly`, this.props.match.params)
        this.makeFullScreen();
        await this.verifyLoggedIn();
        const month = parseInt(this.props.match.params.month);

        await this.loadNewMonth(
            this.props.match.params.buildingID,
            this.props.match.params.year,
            month
        );
        this.bindTablesQuickSearch();
    }

    async onMonthChanged(newMonthAndYearSelected){

        let parts = newMonthAndYearSelected.value.split('_');
        let newYear = parts[1];
        let newMonth = parseInt(parts[0]);
        BllinkLogger.info(`newMonthAndYearSelected ${newMonthAndYearSelected} newYear ${newYear} ${newMonth}`);

        const buildingID = this.props.match.params.buildingID;
        // data-excel-title attribute is sticky without reloading tried for over 2 hours. fallback to page refresh
        window.location.href = `/${constants.pages.monthlyCashFlowUrl}/${buildingID}/${newMonth}/${newYear}`
        // this.props.history.push(`/${constants.pages.monthlyCashFlowUrl}/${buildingID}/${newMonth}/${newYear}`)

        await this.loadNewMonth(buildingID, newYear, newMonth);
    }

    async loadNewMonth(buildingID, year, month){
        this.startLoader();
        const result = await this.fetchMonthlyCashFlow(
            buildingID,
            year,
            month
        );
        const building = await this.fetchBuildingData(buildingID, {urlParams: {skipDisabledCheck: true}});
        if (result?.paymentResults) {
            let rows = result.paymentResults;
            rows = rows.map((res) => {
                const row = {
                    ...res,
                    translatedMethod: res.Method ? this.props.t([`buildings.${res.Method}`, 'buildings.unknownPaymentMethod']) : ''
                }
                /*Added due to https://bllink.atlassian.net/jira/software/projects/SSB/boards/7?assignee=63df7122a5d0c826306ba6a5&selectedIssue=SSB-1212*/
                if (constants.APIContract.paymentStates.CANCELED_PAYMENT_STATUSES.includes(res.PaymentState) && res.Amount < 0) {
                    row.Comment = row.Comment?.length > 0 ? row.Comment.concat('-' + this.props.t('reports.refund.refund')) : this.props.t('reports.refund.refund');
                }
                return row;
            });

            let totalAmount = result.Total;
            let totalAmountInCreditCard = result.TotalInCreditCard;
            let totalAmountInCheques = result.TotalInCheque;
            let totalFutureAmount = result.TotalFuture;
            BllinkLogger.info(`MonthlyCashFlowTable rows are `, rows);
            rows = rows.sort(this.sortApartmentNumbersForTable);
            let newExcelTitle = await this.excelReportTitle(buildingID, year, totalAmount, month);
            this.setState({
                loaded: true,
                rows,
                totalAmount,
                totalAmountInCreditCard,
                totalAmountInCheques,
                totalFutureAmount,
                monthInt: parseInt(month),
                excelReportTitle: newExcelTitle,
                currency: building.currency,
            })
        }
        this.endLoader();
    }

    async excelReportTitle(buildingID, year, totalAmount, month){
        const title = await this.buildingTitleText(buildingID);
        this.setState({
            title
        });
        return `${this.props.t('payments.month_selected')} ${this.props.t(`common.months.${month}`)} - ${title}`;
    }

    onChequeDepositClick(){
        return `/${constants.pages.monthlyChequesUrl}/${this.props.match.params.buildingID}/${this.props.match.params.month}/${this.props.match.params.year}`;
    }


    tableSubTitle(){
        const {t} = this.props;

        let creditValue, creditCurrency, futureValueFloat, futureValue, futureCurrency;
        if (this.state.totalAmountInCreditCard) {
            creditValue = this.state.totalAmountInCreditCard.value;
            creditValue = this.StringUtils.numberWithCommas(creditValue);
            creditCurrency = t(`currency.${this.state.totalAmountInCreditCard.currency}`);
        }

        if (this.state.totalFutureAmount) {
            futureValueFloat = parseFloat(this.state.totalFutureAmount.value);
            futureValue = this.StringUtils.numberWithCommas(futureValueFloat);
            futureCurrency = t(`currency.${this.state.totalFutureAmount.currency}`);
        }

        return (
            <>
                {this.state.totalAmountInCreditCard && (
                    <div className='title_wrapper'>
                        {t('reports.monthly_cashflow_sub_title')}
                        <span className={`currency_header ${StringUtils.checkReverseCurrencyOrder(creditCurrency, t) ? 'turn_currency' : ''}`}>
                            <span>{creditValue}</span>
                            <Currency>{this.state.totalAmountInCreditCard.currency}</Currency>
                        </span>
                        {/*
                            NOTE: this value do not match monthly table total in credit card value, the relationship is next
                                  dashboard_total === monthly_card_total - last_month_tourist + this_month_tourist + refunds
                                  monthly_card_total = payment_total + last_month_tourist - refunds
                                  dashboard_total = payment_total + this_month_tourist
                        */}
                    </div>
                )}
                {futureValueFloat > 0 && (
                    <div className='title_wrapper mt-1'>
                        {t('reports.monthly_cashflow_sub_title_future')}
                        <span className={`currency_header ${StringUtils.checkReverseCurrencyOrder(futureCurrency, t) ? 'turn_currency' : ''}`}>
                            <span>{futureValue}</span>
                            <Currency>{this.state.totalFutureAmount.currency}</Currency>
                        </span>
                    </div>
                )}
            </>
           )
     }


    render() {
        const { t } = this.props;
        this.setBodyClasses([constants.backgroundOptions.cashflow_monthly, constants.backgroundOptions.report]);
        const buildingID = this.props.match.params.buildingID;
        const year = this.props.match.params.year;
        const month = parseInt(this.props.match.params.month);

        let monthTotal = this.Money.roundNumber(this.state.totalAmount?.value);
        monthTotal = this.StringUtils.numberWithCommas(monthTotal);
        const currency = this.state.currency == null ? '' : t(`currency.${this.state.currency}`);
        const tableTitle = (
            <span className='title_wrapper'>
                {t('reports.monthly_cashflow_table_title', {monthName: t(`common.months.${month}`), year: year})}
                <span className={`currency_header ${StringUtils.checkReverseCurrencyOrder(currency, t) ? 'turn_currency' : ''}`}>
                    <span>{monthTotal}</span>
                    <Currency>{this.state.currency}</Currency>
                </span>
            </span>
        )
        const tableSubTitle = this.tableSubTitle();
        const hasSomeChequePayments = (this.state.totalAmountInCheques && this.state.totalAmountInCheques.value > 0);

        const shouldLoadEmpty = (!this.state.userCheck || !this.state.loaded)
        if (shouldLoadEmpty){
            return (<div className="div-buffer-empty-content"/>)
        }

        BllinkLogger.info(`rendering monthly cashflow table main `, this.state)

        return (
            <Translation>{(t, {_}) =>
                <div>
                    <h1 className='page-title'>
                        {this.state.title && (
                            <span className='building-title'>{this.state.title}</span>
                        )}
                    </h1>
                    <MonthlyReportsTable
                        tableData={this.state.rows}
                        tableTitle={tableTitle}
                        tableSubtitle={tableSubTitle}
                        year={year}
                        currentMonth={month}
                        onMonthChange={this.onMonthChangedFunc}
                        exportTitle={this.state.excelReportTitle}
                        building={buildingID}
                        showChequeDeposit={hasSomeChequePayments}
                        onChequeDepositClick={this.onChequeDepositClickFunc}
                    />
                </div>
            }</Translation>
        )
    }
}


export default withTranslation()(MonthlyCashFlowTable)
